import React from 'react'
import { Heart } from 'lucide-react'
import { Button } from '../components/ui/Button'
import useAuthStore from '../store/auth'
import { Link } from 'react-router-dom'

const FavoritesPage = () => {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">💝</div>
        <h2 className="text-2xl font-display font-bold text-gray-900 mb-4">
          Your Favorites Await
        </h2>
        <p className="text-gray-600 mb-6">
          Sign in to save your favorite recipes and access them anytime
        </p>
        <Button asChild>
          <Link to="/login">Sign In</Link>
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="text-center py-12">
        <Heart className="w-16 h-16 mx-auto text-gray-300 mb-4" />
        <h2 className="text-2xl font-display font-bold text-gray-900 mb-4">
          No Favorites Yet
        </h2>
        <p className="text-gray-600 mb-6">
          Start exploring recipes and save the ones that spark joy
        </p>
        <Button asChild>
          <Link to="/recipes">Discover Recipes</Link>
        </Button>
      </div>
    </div>
  )
}

export default FavoritesPage